import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
	IIdentificationData,
	IPatchChangeTagIdProps,
	ShiftOptions,
} from 'models/ICattlesData'
import cattlesApiServices from 'services/cattlesApiServices'
import { useAppDispatch } from 'store/hooks'
import { notifyUser } from 'store/notificationsSlice'

export interface IChangeIdentificationProps extends IPatchChangeTagIdProps {
	date: number
	gate: number[]
	shift: string
	cow_id: number
}

export interface ChangeIdentificationProps {
	rec_date: number
	camera_id: number
	day_period: ShiftOptions
	page: number
	page_size: number
}

export const useChangeIdentification = (props: ChangeIdentificationProps) => {
	const queryClient = useQueryClient()
	const dispatch = useAppDispatch()

	return useMutation<any, AxiosError, IChangeIdentificationProps>({
		mutationFn: (props: IChangeIdentificationProps) => {
			const { date, gate, shift, cow_id, ...patchProps } = props
			return cattlesApiServices.patchTagIdIdentification(patchProps)
		},
		retry: 1,
		onSuccess: (_data, variables) => {
			const { cow_id, gate, shift, date } = variables

			queryClient.setQueryData<any>(
				[
					'identificationList',
					{
						...props,
					},
				],
				oldData => {
					if (!oldData) return oldData

					const updatedResults = oldData.results.map(
						(item: IIdentificationData) => {
							if (item.cow_id === cow_id) {
								return {
									...item,
									tag_id: variables.body.tag_id,
									manually_identified: true,
								}
							}
							return item
						},
					)

					return {
						...oldData,
						results: updatedResults,
					}
				},
			)
			dispatch(
				notifyUser({
					title: 'Успех',
					description: `Корова ${variables.body.tag_id} оцифрована`,
					isError: false,
				}),
			)
		},
		onError: (_error, variables) => {
			dispatch(
				notifyUser({
					title: `Произошла ошибка при оцифровке коровы - ${variables.body.tag_id}`,
					description: 'Попробуйте ещё раз',
					isError: true,
				}),
			)
		},
	})
}
